var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-box"},_vm._l((_vm.list),function(item,index){return _c('p',{key:index},[_c('i',[_vm._v(_vm._s(item.id)+" /")]),_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }